// extracted by mini-css-extract-plugin
export default {"draggable":"Card_draggable__8fT1w","dragging":"Card_dragging__QHxPg"};